import { Action } from '@ngrx/store';
import {
    ActionOptionsArgs,
    BaseAction,
    PersistableAction,
    SynchronisableAction
} from '../../../core/store/actions/base-actions';
import { Account } from './account.model';

export const ENTITY = 'account';
export const SEARCH = '[Account] Search';
export const SELECT = '[Account] Select';
export const SUBMIT = '[Account] Submit';
export const REHYDRATE = '[Account] Rehydrate';
export const REMOVE = '[Account] Remove';
export const ACTIVE_CHANGED = '[Account] Active Account Changed';

export class SearchAction extends BaseAction {
    readonly entity = ENTITY;
    readonly type = SEARCH;

    constructor(public payload: string, options?: ActionOptionsArgs) {
        super(payload, options);
    }
}

export class SelectAction extends PersistableAction {
    readonly entity = ENTITY;
    readonly type = SELECT;

    constructor(public payload: string, options?: ActionOptionsArgs) {
        super(payload, options);
    }

    getKey(): string {
        return `${this.entity}:selected`;
    }
}

export class SubmitAction extends SynchronisableAction {
    readonly entity = ENTITY;
    readonly type = SUBMIT;

    constructor(public payload: Account, options?: ActionOptionsArgs) {
        super(payload, options);
    }

    getKey(): string {
        return `${this.entity}:entity:${this.payload.id}`;
    }
}

export class RehydrateAction implements Action {
    readonly entity = ENTITY;
    readonly type = REHYDRATE;

    constructor(public payload: Array<Action>) {

    }
}

export class RemoveAction extends SynchronisableAction {
    readonly entity = ENTITY;
    readonly type = REMOVE;

    constructor(public payload: Account, options?: ActionOptionsArgs) {
        super(payload, options);
    }

    getKey(): string {
        return `${this.entity}:entity:${this.payload.id}`;
    }
}

export class ActiveAccountChangedAction implements Action {
    readonly type = ACTIVE_CHANGED;

    constructor(public payload: {from: string, to: string}) {
    }
}

export type Actions
    = SearchAction
    | SelectAction
    | SubmitAction
    | RehydrateAction
    | RemoveAction
    | ActiveAccountChangedAction;



// WEBPACK FOOTER //
// ./src/vas/business-objects/account/account.actions.ts